import {Injectable} from "@angular/core";
import "rxjs/add/operator/toPromise";
import {ApiService} from "./api";

declare var $: any;

@Injectable()
export class ArticleService {
    public articles: any;
    public page: number;

    constructor(public api: ApiService) {
    }

    public load(page?:number) : Promise<any> {
        if(page == this.page) {
            return;
        }
        this.page = page;
        return this.api.call('home/index/index', {page: page}).then((result) => {
            var data = result;
            this.articles = data.data;
            return this.articles;
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/service/article.ts